<template>
  <div id="viewNews">
    <div class="container box">
      <div class="bioflinNews">
        <div class="news_top">
          <h3>
            {{data.title}}
          </h3>
          <div class="news_name">
            <span v-for="(item,index) in writer" :key="index">{{item}}</span>
          </div>
          <p class="news_info">{{data.organization}}</p>
          <div class="news_content">
           {{data.abstract}}
          </div>
          <div class="news_btn">
            <a :href="serve +data.text_file" target="_blank" rel="noopener noreferrer">在线阅读</a>
          </div>

          <div align="right" style="padding:20px 20px 0 0;">
            <el-button type="text" @click="addFav">
              <span :class="data.is_collect?'lv0Text':'lv3Text'">
                <i class="fas fa-star"></i>
              </span>
            </el-button>
            <el-button type="text" @click="addLike">
              <span :class="data.is_like?'lv0Text':'lv3Text'">
                <i class="fas fa-thumbs-up"></i>
              </span>
            </el-button>
            <span v-if="$store.state.isLogin"></span>
          </div>
          <div class="padding1">
            <div class="d1">
              <span class="d2">说点什么</span>
            </div>
            <div class="clear l" v-if="data.user">
              <div class="clear-item">
                <img :src="data.user.headImg" class="avatar">
              </div>
              <div class="clear-item nickname lv2Text">{{data.user.nickname}}</div>
            </div>
            <el-input type="textarea" v-model="form.comment" placeholder="发表你的观点吧"></el-input>

            <div style="padding:30px 0">
              <el-button style="width:98px;" type="primary" @click="submit">发表</el-button>
            </div>
            <div class="d1">
              <span class="d2">热门评论</span>
            </div>
            <div v-if="empty" class="lv3Text empty">
              <div style="padding:30px 0">
                <object
                  :data="serve + '/images/slow_working.svg'"
                  type="image/svg+xml"
                  style="width:15%;"
                ></object>
              </div>
              <div>暂无评论</div>
            </div>
            <div v-else>
              <div v-for="(item,index) in comments" :key="index" class="c-item">
                <div class="clear" style="margin-bottom:10px">
                  <div class="clear-item">
                    <img :src="item.headImg" class="avatar">
                  </div>
                  <div class="clear-item nickname lv2Text">
                    {{item.nickname}}
                    <span
                      style="font-size:12px;margin-left:10px;"
                      class="lv3Text"
                    >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm')}}</span>
                  </div>
                </div>
                <div>{{item.content}}</div>
              </div>
              <div class="pager" align="center">
                <el-pagination
                  background
                  hide-on-single-page
                  layout="prev, pager, next"
                  :total="c_total"
                  :page-size="10"
                  :current-page.sync="c_currentPage"
                  @current-change="c_changePage"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="news_right">
        <div class="right_top">
          <div class="span_i"></div>
          <div class="span_title">更多论文</div>
        </div>
        <div class="news_article" v-for="(items,index) in paper" :key="index">
          <div class="news_article_img">
            <img :src="serve + items. cover" alt>
          </div>
          <div @click="changeContent(items.id)" class="news_article_content">
            {{items.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";

export default {
  components: {
    pdf,
    SquareLoader
  },
  data() {
    return {
      serve: this.$store.state.serve,
      c_currentPage: 1,
      c_total: 0,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: {},
      currentPage: 1,
      pageCount: 0,
      form: {},
      comments: [],
      loading: false,
      empty: null,
      loading: true,
      writer:[],
      paper:[]
    };
  },
  created() {
    this.$store.state.user_location = "Bioflin News";
    this.initData();
    this.file1();
  },
  methods: {
    changeContent(id){
      this.$router.push({
        path:'/viewNews?id=' + id
      })
    },
    file1(v){
      this.axios.get(this.serve + '/more_bioflinnews').then(res=>{
        this.paper = res.data
      })
    },
    addLike() {
      if (this.data.is_like) {
        this.axios
          .get(this.serve + "/collect/cancel_like_bioflinnews", {
            params: {
              mobile: this.mobile,
              token: this.token,
              id: this.$route.query.id
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.initData();
            }
          });
      } else {
        this.axios
          .get(this.serve + "/collect/like_bioflinnews", {
            params: {
              mobile: this.mobile,
              token: this.token,
              id: this.$route.query.id
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.initData();
            }
          });
      }
    },
    addFav() {
      if (this.data.is_collect) {
        this.axios
          .get(this.serve + "/collect/cancel_bioflinnews", {
            params: {
              mobile: this.mobile,
              token: this.token,
              id: this.$route.query.id
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.initData();
            }
          });
      } else {
        this.axios
          .get(this.serve + "/collect/collect_bioflinnews", {
            params: {
              mobile: this.mobile,
              token: this.token,
              id: this.$route.query.id
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.initData();
            }
          });
      }
    },
    submit() {
      this.axios
        .get(this.serve + "/collect/comment_bioflinews", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.$route.query.id,
            content: this.form.comment
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.form = {};
            this.$message({
              message: "评论已发布",
              type: "success"
            });
            this.axios
              .get(this.serve + "/bioflinnews_comment", {
                params: {
                  id: this.$route.query.id
                }
              })
              .then(res => {
                if (res.data.total > 0) {
                  this.empty = false;
                  this.comments = res.data.comment;
                }
              });
          }
        });
    },
    changePage(v) {
      this.currentPage = v;
    },
    c_changePage(v) {
      this.axios
        .get(this.serve + "/bioflinnews_comment", {
          params: {
            id: this.$route.query.id,
            page: v
          }
        })
        .then(res => {
          if (res.data.total > 0) {
            this.empty = false;
            this.comments = res.data.comment;
            this.c_total = res.data.total;
          } else {
            this.empty = true;
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/bioflinnews_detail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.writer = res.data.data.results.writer.split(';')
        });

      this.axios
        .get(this.serve + "/bioflinnews_comment", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(res => {
          if (res.data.total > 0) {
            this.empty = false;
            this.comments = res.data.comment;
            this.c_total = res.data.total;
          } else {
            this.empty = true;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#viewNews {
  padding-bottom: 60px;
  .box {
    display: flex;
    justify-content: space-between;
  }
  .bioflinNews {
    width: 830px;
    background: rgba(255, 255, 255, 1);
    .news_top {
      padding: 34px 60px;
      font-family: "MicrosoftYaHei";
      h3 {
        line-height: 30px;
        font-size: 24px;
        font-weight: 400;
        text-align: center;
        color: rgba(51, 51, 51, 1);
      }
      .news_name {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        span {
          margin-left: 19px;
        }
      }
      .news_info {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(221, 221, 221, 1);
      }
      .news_content {
        font-size: 18px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 40px;
      }
      .news_btn {
        width: 138px;
        height: 40px;
        background: linear-gradient(
          0deg,
          rgba(226, 33, 28, 1),
          rgba(255, 116, 112, 1)
        );
        border-radius: 4px;
        margin: 0 auto;
        margin-top: 73px;
        
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        a{
          color: rgba(255, 255, 255, 1);
        }
      }
      .news_btn:hover {
        background: linear-gradient(
          0deg,
          rgba(255, 116, 112, 1),
          rgba(226, 33, 28, 1)
        );
      }
      .padding1 {
        .c-item {
          border-bottom: 1px solid #ddd;
          margin-bottom: 10px;
          padding: 10px 0;
        }
        .empty {
          padding: 20px 0;
        }
        padding-bottom: 50px;
        .l {
          padding: 20px 0;
        }
        .avatar {
          border-radius: 50px;
          margin-right: 10px;
          height: 50px;
          width: 50px;
        }
        .nickname {
          line-height: 50px;
        }
        .d2 {
          border-bottom: 5px solid #e2211c;
          padding: 10px 0;
          position: relative;
          top: -5px;
        }
        .d1 {
          border-bottom: 1px solid #ddd;
          padding: 10px 0;
          margin-bottom: 10px;
        }
      }
    }
  }
  .news_right {
    width: 350px;
    height: 336px;
    .right_top {
      width: 100%;
      height: 58px;
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      background: rgba(255, 255, 255, 1);
      .span_i {
        width: 4px;
        height: 20px;
        background: rgba(246, 78, 98, 1);
        margin-right: 15px;
        margin-left: 20px;
      }
    }
    .news_article {
      width: 350px;
      height: 336px;
      padding-top: 30px;
      background: rgba(255, 255, 255, 1);
      .news_article_img {
        width: 290px;
        height: 220px;
        margin: 0 auto;
        img{
          width: 290px;
          height: 220px;
        }
      }
      .news_article_content{
        padding-top: 20px;
        width: 290px;
        margin: 0 auto;
        line-height: 20px;
        cursor: pointer;
      }
      .news_article_content:hover{
        color: #e2211c;
      }
    }
  }
}
</style>